<div class="container third-container p-0">
  <div class="row d-flex align-items-center">
    <div class="third-section-background-wrapper">
      <img id="third-section-background" src="assets/homepage/digital-handshakes/background.svg" alt="third section background S">
    </div>

    <div class="third-section-left col-6">
      <img src="assets/homepage/digital-handshakes/handshake.png" alt="third section pic" class="i-width-100">
    </div>
    <div class="third-section-right col-6">
      <span class="third-section-title">{{'home-page-content.discover_title' | translate}}</span>
      <span class="third-section-subtitle mt-4">
         {{'home-page-content.discover_description' | translate}}
      </span>
    </div>
  </div>
</div>

<section class="section-wrapper-mb third-container-mb">
  <div class="flex-direction-column">
    <div class="third-section-title-wrapper-mb">
      <span class="third-section-title" [ngClass]="{'third-section-title-am': currentLang === Language.HY}">{{'home-page-content.discover_title' | translate}}</span>
    </div>
    <span class="third-section-subtitle mt-4">{{'home-page-content.discover_description' | translate}}</span>
    <div class="mt-3">
      <img src="assets/homepage/digital-handshakes/handshake.png" alt="third section pic" class="i-width-100">
    </div>
  </div>
</section>
